import React, { useState } from 'react'
import { Box, Typography, Button, Snackbar, Alert, BottomNavigation, BottomNavigationAction, Grid, Modal } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'
import { useNavigate, useParams } from 'react-router-dom';
import { isEmpty } from 'lodash'


const EditProduct = (props) => {

  const data = useParams();

  const [alertText, setAlertText] = React.useState('');
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [alertSuccess, setAlertSuccess] = React.useState('');
  const [orderData, setOrderData] = React.useState({});


  const darkBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }

  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const closeSuccess = () => {
    setOpenSuccess(false)
  }

  const handleAlertSuccess = (message) => {
    setAlertSuccess(message)
    setOpenSuccess(true)
    setTimeout(() => {
      setAlertSuccess('')
      setOpenSuccess(false)
    }, 3000)
  }



  const navigate = useNavigate();


  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }


  function extractString(data) {
    const jsonString = data
    const jsonObject = JSON.parse(JSON.stringify(jsonString));
    const enSaValue = jsonObject['en-SA'];
    return enSaValue
  };




  React.useEffect(() => {
    axios.get(`${legolasApi.url}/admin/products/${data.id}`).then((res) => {
      console.log('search res: ', res.data.data)
      const list = res.data.data
      setOrderData(list)
    }).catch((error) => console.log('Error', error))
  }, [])



  if (isEmpty(orderData)) {
    return null;
  }


  return (

    <Box sx={{ width: '97%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', margin: '30px 20px', marginBottom: '-5px',
        '& .MuiTypography-root': {
          fontSize: '2.5rem',
          fontWeight: 400,
          color: '#000'
        }
      }}>
        <Typography>#{data.id}</Typography>
      </Box>
      <Box sx={{
        display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
      }}
      >
        <Button onClick={() => navigate(-1)}>Back</Button>

      </Box>
      <Box id='order-container'>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>Product & Price Information</Typography>
        </Box>
        {/* <Grid container spacing={5} columns={24}> */}
        <Grid item xs={12}>

          <Typography variant='subtitle1' sx={subHeader}>
            Product  Information
          </Typography>


          <Box sx={darkBox}>
            <Typography>SKU:{ }</Typography>

            <Typography>{orderData.system ? (
              <Typography>{orderData.system.sku}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>
          </Box>
          <Box sx={lightBox}>
            <Typography>MageId:</Typography>
            <Typography>{orderData.mageId ? (
              <Typography>{orderData.mageId}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          <Box sx={darkBox}>
            <Typography>Type:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{orderData.system.type}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          {/* <Box sx={lightBox}>
          <Typography>Attribute Set:</Typography>
          <Typography>{orderData.system ? (
          <Typography>{orderData.system.attributeSet}</Typography>
        ) : (
          <Typography>Loading...</Typography>
        )}</Typography>
        </Box> */}
          <Box sx={lightBox}>
            <Typography>Barcode:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{orderData.system.barcode}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          <Box sx={darkBox}>
            <Typography>GTIN:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{orderData.system.gtin}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          {/* <Box sx={darkBox}>
          <Typography>Brand:</Typography>
          <Typography></Typography>
        </Box> */}
          <Box sx={lightBox}>
            <Typography>  Global Brand:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{orderData.system.globalBrand}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          <Box sx={darkBox}>
            <Typography>Status:</Typography>
            {/* <Typography>{orderData.system.status}</Typography> */}

            <Typography>{orderData.system.status !== null ? (
              <Typography>{orderData.system.status ? 'Enabled' : 'Disabled'}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          {/* <Box sx={lightBox}>
          <Typography>Categories:</Typography>
          <Typography>{orderData.categories ? (
          <Typography>{orderData.categories}</Typography>
        ) : (
          <Typography>Loading...</Typography>
        )}</Typography>
        </Box>
        <Box sx={darkBox}>
          <Typography>  Primary Categories::</Typography>
          <Typography>{orderData.primaryCategory ? (
            <Typography>{orderData.primaryCategory}</Typography>
          ) : (
            <Typography>Loading...</Typography>
          )}</Typography>

        </Box> */}

        </Grid>


        {/* </Grid> */}
        <Grid item xs={12}>
          <Typography variant='subtitle1' sx={subHeader}>
          </Typography>
          <Box sx={darkBox}>
            <Typography>Name:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{extractString(orderData.system.name)}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>
          </Box>
          <Box sx={lightBox}>
            <Typography>Url Key:</Typography>
            <Typography>{orderData.system ? (
              <Typography>{extractString(orderData.system.urlKey)}</Typography>
            ) : (
              <Typography>Loading...</Typography>
            )}</Typography>

          </Box>
          {/* <Box sx={darkBox}>
                <Typography>Breadcrumb:</Typography>
                <Typography>{orderData.system ? (
          <Typography>{extractString(orderData.system.breadcrumb)}</Typography>
        ) : (
          <Typography>Loading...</Typography>
        )}</Typography>

              </Box> */}
          <Box sx={darkBox}>
            <Typography>Google Product Category:</Typography>
            <Typography>
              {orderData.googleCategories !== undefined ? (
                <Typography>{orderData.googleCategories}</Typography>
              ) : (
                <Typography>Not Available</Typography>
              )}
            </Typography>


          </Box>

        </Grid>
      </Box>
      <Grid item xs={12}>
        <Typography variant='subtitle1' sx={subHeader} marginTop='20px'>
          Price Information
        </Typography>
        <Box sx={darkBox}>
          <Typography>Original Price:</Typography>
          <Typography>{orderData.price && orderData.price.price && orderData.price.price.invoicePrice !== null ? (
            <Typography>{orderData.price.price.invoicePrice}</Typography>
          ) : (
            <Typography>0</Typography>
          )}</Typography>
        </Box>
        <Box sx={lightBox}>
          <Typography>Invoice Price:</Typography>
          <Typography>{orderData.price && orderData.price.price && orderData.price.price.invoicePrice !== null ? (
            <Typography>{orderData.price.price.invoicePrice}</Typography>
          ) : (
            <Typography>0</Typography>
          )}
          </Typography>

        </Box>
        <Box sx={darkBox}>
          <Typography>Cost Price:</Typography>
          <Typography>
            {orderData.price && orderData.price.prc && orderData.price.prc.costPrice !== null ? (
              <Typography>{orderData.price?.prc.costPrice}</Typography>
            ) : (
              <Typography>0</Typography>
            )}
          </Typography>
        </Box>

      </Grid>
      <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
          </Typography>
        </Box>
      </Box>
    </Box>


  )
}
export default EditProduct;